import React, {
  useCallback,
  useState,
  useEffect,
  forwardRef,
  useRef,
  useImperativeHandle,
} from "react";
import {
  DropZone,
  Stack,
  FormLayout,
  TextField,
  Thumbnail,
  Checkbox,
  Toast,
  Button,
  Text,
  Loading,
  ButtonGroup,
  Select,
  InlineError,
} from "@shopify/polaris";
import { useParams } from "react-router-dom";
import axios from "../Assets/Lib/axios";
import { NoteMinor } from "@shopify/polaris-icons";
import { Editor } from "@tinymce/tinymce-react";
import EditorTiny from "./EditorTiny";
import showTools from "../Assets/Images/show-tools.svg";
import hideTools from "../Assets/Images/hide-tools.svg";
import axiosDefault from "axios";
import LoadingScreen from "../Components/LoadingScreen";
const ListItemAdd = forwardRef((props, ref) => {
  const [boolRichTextTools, setBoolRichTextTools] = useState(false);
  let object = "";
  const { id } = useParams();
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [item, setItem] = useState({
    title: "",
    titleTranslated: "",
    ctaText: "",
    ctaTextTranslated: "",
    ctaLink: "",
    ctaLinkTranslated: "",
    textTranslated: "",
    active: 1,
    subtitle: "",
    subtitleTranslated: "",
  });
  const handleSelectChangeLanguage = (value) => {
    setSelectedLanguage(value);
    setItem({
      ...item,
      titleTranslated:
        object?.title && object?.title[value] && object?.title[value],
      subtitleTranslated:
        object?.subtitle && object?.subtitle[value] && object?.subtitle[value],
      ctaTextTranslated:
        object?.details?.cta_text &&
        object?.details?.cta_text[value] &&
        object?.details?.cta_text[value],
    });
  };
  const [translatedButtonClicked, setTranslatedButtonClicked] = useState(false);
  const handleTranslate = () => {
    setTranslatedButtonClicked(!translatedButtonClicked);
  };
  const handleChangeTitle = (value) => {
    setItem({ ...item, title: value });
    setTitleError("");
  };

  const [titleError, setTitleError] = useState("");
  const handleChangeSubtitle = (value) => {
    setItem({ ...item, subtitle: value });
  };
  const handleChangeCtaText = (value) => {
    setItem({ ...item, ctaText: value });
  };
  const handleChangeCtaLink = (value) => {
    setItem({ ...item, ctaLink: value });
  };
  const handleChangeText = (value) => {
    !translatedButtonClicked && setItem({ ...item, text: value });
  };
  const handleChangeTitleTranslated = (value) => {
    setItem({ ...item, titleTranslated: value });
  };
  const handleChangeSubtitleTranslated = (value) => {
    setItem({ ...item, subtitleTranslated: value });
  };
  const handleChangeCtaTextTranslated = (value) => {
    setItem({ ...item, ctaTextTranslated: value });
  };
  const handleChangeCtaLinkTranslated = (value) => {
    setItem({ ...item, ctaLinkTranslated: value });
  };
  const handleChangeTextTranslated = (value) => {
    setItem({ ...item, textTranslated: value });
  };
  const [checked, setChecked] = useState(false);
  const handleChange = (newChecked) => {
    setItem({ ...item, active: newChecked });
  };
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload actionHint={"Accepts pngs, jpegs, svgs and jsons"} />
  );
  const uploadedFile = file && (
    <Stack>
      {/* <Thumbnail
        size="small"
        alt={file.name}
        source={
          validImageTypes.includes(file.type)
            ? window.URL.createObjectURL(file)
            : NoteMinor
        }
      /> */}
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const [imageError, setImageError] = useState("");

  const imageKey = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "section");
    form_data.append("section_type", "list");
    form_data.append("image[en]", file[file.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(file[file.length - 1].type) > 0
              ? window.URL.createObjectURL(file[file.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  // useEffect(() => {
  //   object = JSON.parse(props.object);
  //   console.log(object?.details?.title && object?.details?.title["en"]);
  //   setItem({
  //     title: object?.title && object?.title["en"] ? object?.title["en"] : "",
  //     ctaText:
  //       object?.details?.cta_text && object?.details?.cta_text["en"]
  //         ? object?.details?.cta_text["en"]
  //         : "",
  //     ctaLink: object?.details?.cta_link ? object?.details?.cta_link : "",
  //     text:
  //       object?.details?.text && object?.details?.text["en"]
  //         ? object?.details?.text["en"]
  //         : "",
  //     active: object?.details?.is_active ? true : false,
  //     image: object?.details?.image ? object?.details?.image : "",
  //   });
  // }, []);
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This image have been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  useImperativeHandle(ref, () => ({
    handleSave() {
      // if (!item.title) {
      //   // !file && setImageError("Please upload an image");
      //   !item.title && setTitleError("This field is required");
      // } else {
      props.showSaving();
      const form_data = new FormData();
      item.title && form_data.append("title[en]", item.title);
      item.subtitle && form_data.append("subtitle[en]", item.subtitle);
      item.text && form_data.append("text[en]", item.text);
      item.ctaLink && form_data.append("cta_link[en]", item.ctaLink);
      item.ctaText && form_data.append("cta_text[en]", item.ctaText);
      item.text && form_data.append("text[en]", item.text);
      item.titleTranslated &&
        form_data.append(`title[${selectedLanguage}]`, item.titleTranslated);
      item.ctaText && form_data.append("cta_text[en]", item.ctaText);
      item.ctaTextTranslated &&
        form_data.append(
          `cta_text[${selectedLanguage}]`,
          item.ctaTextTranslated
        );
      form_data.append("is_active", item.active ? 1 : 0);
      file && form_data.append("image[en]", imageKey.current);
      axios
        .post(`/sections/${props.sectionId}/list`, form_data)
        .then((res) => {
          props.handleSaveAndRefresh();
          props?.refreshApi();
        })
        .catch(function (error) {
          if (error.response) {
            setToastContent(error.response.data.message);
            toggleActive();
            props.removeSaving();
          }
        });
      // }
    },
  }));
  return (
    <FormLayout>
      {/* <div style={{ float: "right" }}>
        <ButtonGroup>
          <Button
            onClick={() => {
              setBoolRichTextTools(!boolRichTextTools);
            }}
            plain
          >
            <img src={boolRichTextTools ? showTools : hideTools} width={22} />
          </Button>
        </ButtonGroup>
      </div> */}

      <table>
        <tbody>
          <tr>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            <th>
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>
            </th>
            {translatedButtonClicked && (
              <th>
                <Select
                  options={props.languagesArray}
                  onChange={handleSelectChangeLanguage}
                  value={selectedLanguage}
                  placeholder="Please select a language"
                />
              </th>
            )}
          </tr>
          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Title
              </Text>
            </td>
            <td>
              <TextField
                value={item.title}
                onChange={handleChangeTitle}
                disabled={translatedButtonClicked}
                error={titleError}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={item.titleTranslated}
                  onChange={handleChangeTitleTranslated}
                />
              </td>
            )}
          </tr>
          {/* <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Subtitle
              </Text>
            </td>
            <td>
              <TextField
                value={item.subtitle}
                onChange={handleChangeSubtitle}
                disabled={translatedButtonClicked}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <TextField
                  value={item.subtitleTranslated}
                  onChange={handleChangeSubtitleTranslated}
                />
              </td>
            )}
          </tr>

          <tr>
            <td>
              <Text variant="bodyMd" as="p" color="subdued">
                Text
              </Text>
            </td>
            <td>
              <EditorTiny
                boolRichTextTools={boolRichTextTools}
                value={item.text}
                handleChangeValue={handleChangeText}
                height={200}
              />
            </td>
            {translatedButtonClicked && (
              <td>
                <EditorTiny
                  boolRichTextTools={boolRichTextTools}
                  value={item.textTranslated}
                  handleChangeValue={handleChangeTextTranslated}
                />
              </td>
            )}
          </tr> */}
        </tbody>
      </table>
      {/* <Text variant="bodyMd" as="p" fontWeight="medium">
        Image
      </Text>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
        }}
      >
        <div style={{ float: "left" }}>
          <Thumbnail size="large" source={item.image ? item.image : ""} />
        </div>
        <div
          style={{
            width: "100%",
            marginLeft: "10px",
          }}
        >
          <DropZone
            accept=".png,.jpeg,.jpg,.svg,.json"
            //   type="file"
            allowMultiple={false}
            onDrop={handleDropZoneDrop}
            onDropAccepted={sendImage}
          >
            {uploadedFile}
            {fileUpload}
          </DropZone>
        </div>
      </div>
      <InlineError message={imageError} /> */}

      <Text variant="bodyMd" as="p" color="subdued">
        Click Save and add all item details on edit
      </Text>
      <Checkbox
        label="Is Active"
        checked={item.active}
        onChange={handleChange}
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </FormLayout>
  );
});
export default ListItemAdd;
